import React from 'react';
//import { Link } from 'react-router-dom';
import './silwanefalls.css';
import { Link } from 'react-router-dom';





const Silwanefalls = () => {
    const handleClick = () => {
        window.scrollTo(0, 0); // Scroll to the top
    };
  
  return (
    <>
    <div className="silwamefallscont">

        <div className="fallsimgcont">
            <img src="https://optimize.sirv.com/silwane/waterfall.jpg" alt="silwanefalls" />
        </div>

        <div className='silwaneintro'>
            <div className='silwaneparasecti'>
                <h2>Waterfalls</h2>
                <p>Welcome to the heart of Silwane Nature Reserve, home to one of our most spectacular natural treasures: a series of beautiful, cascading waterfalls. These falls are a truly breathtaking sight when flowing, offering incredible photographic opportunities and a peaceful, immersive nature experience.</p>
                <p>Our waterfalls are entirely dependent on the natural cycle of rainfall and the overflow of the dam located upstream. This means their appearance is a glorious, yet seasonal spectacle. During the rainy season (typically November to April).</p>
            </div>
            <Link 
                to="/gallery" 
                onClick={handleClick}
                //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                state = {{
                    data: { majorevents: "waterfalls", abt: "" } 
                }}
                style={{ textDecoration: 'none', color: 'black' }}
            >
            <div className="silwanefallsbutton">
                <p>Learn More</p>
            </div>
            </Link>
        </div>
      
    </div>

    
   
    </>
  );
};
  
export default Silwanefalls;
  